import React from 'react'
import Cleave from 'cleave.js/dist/cleave-react'

const manualRate = ({option, rate, totalCost, onBlurHandler, disabled}) => {

    const onBlur = event => {
        const rate = Number.parseFloat(event.target.value)
        if (!Number.isNaN(rate)) {
            onBlurHandler(
                {
                    [option.value]:  Number(((rate * Number(totalCost)) / 1000).toFixed(2))
                },
                undefined,
                undefined,
                rate
            )
        }
    }

    return (
        <Cleave
            className="form-control number-control input-numeral"
            disabled={disabled}
            autoComplete={false}
            value={rate}
            options={{
                numeral: true,
                numeralPositveOnly: true,
                numeralThousandsGroupStyle: 'none',
                numeralDecimalScale: 2,
                numeralDecimalMark: '.',
            }}
            onBlur={onBlur}
        />
    )
}

export default manualRate